










































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import UsersList from './components/Users/UsersList.vue'
import UsersStatistics from './components/UsersStatistics/UsersStatistics.vue'
import UtmStatistics from './components/UtmStatistics.vue'
import { BotUsersConfig } from './types'

enum Tabs {
  statistic,
  users,
  utm
}

@Component({
  components: {
    UtmStatistics,
    UsersStatistics,
    UsersList,
  },
  data() {
    return {
      Tabs,
    }
  }
})
export default class BotUsers extends Vue {
  @Prop() config!: BotUsersConfig

  activeTab = Tabs.users

  selectedUtm: string | null = null
}
